import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home.vue'
import SmartRewards from '@/components/SmartRewards.vue'
import SignUp from '@/components/SignUp.vue'
import SignIn from '@/components/SignIn.vue'
import ResetPassword from '@/components/ResetPassword.vue'
import ProductDetail from '@/components/ProductDetail.vue'
import PostDetail from '@/components/PostDetail.vue'
import InfoPage from '@/components/InfoPage.vue'
import ContentPage from '@/components/ContentPage.vue'
import XigCheckHome from '@/components/xigcheck/XigCheckHome.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: ContentPage
    },
    {
      path: '/terms-of-service',
      name: 'TermsOfService',
      component: ContentPage
    },
    {
      path: '/smartrewards',
      name: 'SmartRewards',
      component: SmartRewards
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/signin',
      name: 'SignIn',
      component: SignIn
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/product/detail/:id',
      name: 'ProductDetail',
      component: ProductDetail
    },
    {
      path: '/article/detail/:articleId',
      name: 'PostDetail',
      component: PostDetail
    },
    {
      path: '/info/:type',
      name: 'InfoPage',
      component: InfoPage
    },
    {
      path: '/content/:type',
      name: 'ContentPage',
      component: ContentPage
    },
    {
      path: '/xigcheck',
      name: 'XigCheckHome',
      component: XigCheckHome
    },
    {
      path: '/xigcheck/:type',
      name: 'XigcheckContentPage',
      component: ContentPage
    }
  ]
})
 
